$(document).ready(function() {
    function isElementInViewport(e) {
        const rect = e.getBoundingClientRect();
        const windowHeight = $(window).height();
        const offset = 100;
        const targetPosition = windowHeight / 2 - offset;

        return (
            rect.top <= targetPosition &&
            rect.bottom >= targetPosition
        );
    }

    function updateBlurClass() {
        // Adds blur to our main image
        if ($('.group.show[data-blur="true"]').length) {
            $('.img-main').addClass('img-blur');
        } else {
            $('.img-main').removeClass('img-blur');
        }
    }

    function updateActiveElement() {
        $('.jobstack-landing .block-item').each(function() {
            if (isElementInViewport(this)) {
                const groupId = $(this).data('group');

                // Remove .show from all items and groups
                $('.jobstack-landing .block-item, .group').removeClass('show');

                // Add .show to the current block-item
                $(this).addClass('show');

                // Add .show to the corresponding group element
                $(`#group-${groupId}`).addClass('show');

                return false;
            }
        });

        updateBlurClass();
    }

    $(window).on('scroll', function() {
        updateActiveElement();
    });

    updateActiveElement();
});
